import { useAuth } from "hooks";
import { isMatch } from "./selectors";
import {
  PACKAGE_ASSESSMENT_ACCESS_ROUTES,
  SCOPE_ACCESS_ROUTES,
} from "./constants";
import { UseAccess } from "./types";

export const useAccess: UseAccess = (pathname = "") => {
  const [auth] = useAuth();
  const { scopesAccess, packageAssessmentsAccess } = auth.data.school;

  if (!scopesAccess && isMatch(pathname, SCOPE_ACCESS_ROUTES)) {
    return "scope";
  }

  if (
    !scopesAccess &&
    !packageAssessmentsAccess &&
    isMatch(pathname, PACKAGE_ASSESSMENT_ACCESS_ROUTES)
  ) {
    return "packageAssessment";
  }
};
